import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const BCXebuyttable = React.memo(function BCXebuyttable(props) {
  const classes = useStyles();
  const { data } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>TT</th>
          <th className={classes.tablebc_th}>Chỉ tiêu</th>
          <th className={classes.tablebc_th}>Đơn vị</th>
          <th className={classes.tablebc_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>1</td>
          <td className={classes.tablebc_td}>Tổng số tuyến</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{data.p2_sotuyen_khaithac}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Số tuyến có trợ giá</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{data.p2_sotuyen_trogia}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>2</td>
          <td className={classes.tablebc_td}>Tổng phương tiện</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{data.p2_sophuongtien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>3</td>
          <td className={classes.tablebc_td}>Tổng số chuyến xe thực hiện</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{data.p2_sochuyenthuchien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>4</td>
          <td className={classes.tablebc_td}>Tỷ lệ thực hiện/kế hoạch</td>
          <td className={classes.tablebc_td}>%</td>
          <td className={classes.tablebc_td}>{data.p2_tylethuchien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>5</td>
          <td className={classes.tablebc_td}>Trợ giá (nếu có)</td>
          <td className={classes.tablebc_td}>1000đ</td>
          <td className={classes.tablebc_td}>{data.p2_trogia}</td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div>
      <table className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCXebuyttable.propTypes = {
  data: PropTypes.object,
};
export default BCXebuyttable;
